module.exports = __webpack_public_path__ + "aefd541e0a7928ecf21ea05c8e176974.png";